import { useSelector } from "react-redux";
import { FloatPanel } from "../../../../../components/floatPanel";
import { AttributeEditor } from "./reference";
import "./reference.css";
export const Edition=()=>{
 const panel=useSelector(state=>state.aplicationConfig.userConfig.floatPanel);
 return <FloatPanel className="attributeReferencePanel" template={<AttributeEditor key={`${panel.queryId}-${panel.isEmpty}`}/>}/>;
};
